import React, { useMemo } from 'react';
import BarDataCard from '../../../HOC/Cards/BarDataCard';
import { exchangeRates } from 'src/const';
import { COLOR_SECONDARY_2, COLOR_SECONDARY_2_600 } from 'src/colors';
import { getDynamicExtraFees } from 'src/utils/functions';
import { Grid } from '@mui/material';
import { VisibleListingsProp } from 'src/interfaces/iproptypes';
import { LoadingCard } from 'src/App/HOC';
import NoDataCard from 'src/App/HOC/Cards/NoDataCard';

const ExtraPricingCard = ({
  listings,
  currency,
  cachedData,
  viewMode,
  isDynamicLoading,
  multipleMarkersCallLoading,
  noDataInMarket,
}: {
  listings: VisibleListingsProp;
  currency: string;
  cachedData?: { [key: string]: number } | null;
  viewMode: 'map' | 'dashboard' | 'discovery' | 'compare' | 'advance' | 'searchListing';
  isDynamicLoading: boolean;
  multipleMarkersCallLoading: Boolean;
  noDataInMarket: boolean;
}) => {
  const isDataStatic = viewMode === 'dashboard' && cachedData;
  const isDataLoading = multipleMarkersCallLoading && !listings.data?.length && !isDataStatic;

  const dynamicExtraFees = useMemo(() => {
    if (isDataLoading) return [];
    return getDynamicExtraFees(listings.data, currency, isDataStatic ? cachedData : null);
  }, [listings, currency, viewMode, cachedData]);

  if (isDataLoading || isDynamicLoading) {
    return <LoadingCard height={150} type="bars" />;
  }

  if (noDataInMarket) {
    return <NoDataCard height={150} borderRadius={8} />;
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      item
      xs={12}
      spacing={1}
      sx={{ padding: '5px', boxShadow: '0 4px 10px #0003', borderRadius: 1 }}
    >
      <BarDataCard
        title="Extra Pricing"
        tooltipContent={'Other fees counted as income'}
        data={dynamicExtraFees}
        orientation="vertical"
        unit={currency}
        label={exchangeRates[currency].symbol}
        graphHeight={150}
        barColor={COLOR_SECONDARY_2_600}
        barAccentColor={COLOR_SECONDARY_2}
      />
    </Grid>
  );
};

export default ExtraPricingCard;
